import {
  PPI_330_ADDITIONAL_PRODUCTS_TAB,
  PPI_330_ADDITIONAL_PRODUCTS_TAB_VARIANTS
} from 'core/constants/experiments'
import { getVariant } from 'core/experiment'

export const enableAdditionalProductsTab = () => {
  const featureFlagEnabled =
    getVariant({
      experimentKey: PPI_330_ADDITIONAL_PRODUCTS_TAB,
      fallback: PPI_330_ADDITIONAL_PRODUCTS_TAB_VARIANTS.CONTROL
    }) === PPI_330_ADDITIONAL_PRODUCTS_TAB_VARIANTS.ADDITIONAL_PRODUCTS_TAB

  return featureFlagEnabled
}
